import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.7 17.7",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M13.6,3.6l-1.4,10.6c0,0,0,.1-.1.2,0,0-.1,0-.2,0l-3.5-1.8-1.3,1.7c0,0-.1,0-.2,0s0,0,0,0c-.1,0-.2,0-.2-.2v-2.3c0,0,0-.1,0-.1l5-6.5-6.5,5.6s0,0-.2,0,0,0-.1,0l-2.3-1.2c0,0-.1-.1-.1-.2s0-.2.1-.2L13.2,3.3c0,0,.2,0,.2,0,0,0,.1.1.1.2Z"
	})
});
export default SvgSend;
